import React from 'react';
import { History } from 'history';

// tslint:disable-next-line:variable-name
export const HistoryContext = React.createContext<History>(null);
